var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-overlay text-center d-flex align-items-center justify-content-center"},[_c('div',[_c('Loader',{attrs:{"color":_vm.color,"size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }